import { render } from "./QueryOtherAbilities.vue?vue&type=template&id=3b159558&class=text-center"
import script from "./QueryOtherAbilities.vue?vue&type=script&lang=js"
export * from "./QueryOtherAbilities.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__